import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
  name: "affiliateForm",
  initialState: {
    isAffiliateFormOpen: false,
  },
  reducers: {
    toogleAffiliateForm: (state) => {
      state.isAffiliateFormOpen = !state.isAffiliateFormOpen;
    },
  },
});

export const { toogleAffiliateForm } = appSlice.actions;
export default appSlice.reducer;